import React, { useCallback, useContext, useEffect } from "react";
import "./Toast.css";
import Exit from "./Icons/Delete";
import Progress from "./Progress";
import { TOAST_TYPE } from "../../constants/Constants";
import toastContext from "../../context/toast/ToastContext";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import themeContext from "../../context/theme/ThemeContext";

const Toast = ({ toastList, setList, progressList, setProgressList }) => {

  const { setBatchAssignClick } = useContext(toastContext);
  const { getAlterColor } = useContext(themeContext);
  const deleteToast = useCallback(
    (id) => {
        const toastListItem = toastList.filter((e) => e.id !== id);
        setList(toastListItem);
    },
    [toastList, setList]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (toastList.length) {
        for (var item of toastList) {
          if(item.toastType !== TOAST_TYPE.BATCHASSIGN){
            deleteToast(item.id);
          }
        }
      }
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, [toastList, deleteToast]);

  const hideProgressToast = (id) => {
    setProgressList((prevList) =>
      prevList.map((p) => (p.id === id ? { ...p, show: false } : p))
    );
  };

  return (
    <div style={!isMobile?{}:{right:"unset"}} className={`toast-containerv2 ${toastList.length > 0 && toastList[0].toastType ==TOAST_TYPE.BATCHASSIGN ?"bottom-centerv2":"bottom-rightv2"}`}>
      {progressList.map((toast, i) => {
        if (!toast.show) return;
        else
          return (
            <div key={i} className="toast-notificationv2 toastv2" style={{background:getAlterColor("#262525","#ffffff"),border:getAlterColor("1px solid rgba(200, 198, 196, 0.32)","1px solid rgb(0 0 0 / 32%)")}}>
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* {toast.icon} */}
                {/* {toast.progress} */}
                <Progress progress={toast.progress} />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <p
                    className="toast-titlev2"
                    style={{
                      color: `${toast.color}`,
                    }}
                  >
                    {toast.title}
                  </p>
                </div>
                <button onClick={() => hideProgressToast(toast.id)}>
                  <Exit />
                </button>
              </div>
            </div>
          );
      })}

      {toastList.map((toast, i) => (
        toast.toastType != TOAST_TYPE.BATCHASSIGN ? (
        <div key={i} className="toast-notificationv2 toastv2" style={{background:getAlterColor("#262525","#ffffff"),border:getAlterColor("1px solid rgba(200, 198, 196, 0.32)","1px solid rgb(0 0 0 / 32%)")}}>
          <div style={{ display: "flex", alignItems: "center" }}>
            {toast.icon}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <p
                className="toast-titlev2"
                style={{
                  color: `${toast.color}`,
                }}
              >
                {toast.title}
              </p>
            </div>
            <button onClick={() => deleteToast(toast.id)}>
              <Exit />
            </button>
          </div>
        </div>
        ) : (
          <div key={i} className="toast-notificationv2-ba toastv2-ba" style={{background:getAlterColor("#262525","#ffffff"),border:getAlterColor("1px solid rgba(200, 198, 196, 0.32)","1px solid rgb(0 0 0 / 32%)")}}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <p className="toast-titlev2-ba">
                {toast.title}
              </p>
            </div>
            <div>
            <button onClick={()=>setBatchAssignClick(true)} className="assign-btn">
              Assign
            </button>
            </div>
            <div style = {{marginLeft:"8px"}}>
            <button onClick={() => deleteToast(toast.id)} className="dismiss-btn">
              Dismiss
            </button>
            </div>
          </div>
        </div> 
        )
      ))}
    </div>
  );
};

export default Toast;
